<template>
  <button
    type="button"
    @click="$emit('click', $event)"
    :class="['flex relative justify-center cursor-pointer focus:shadow-outline rounded-full p-2 -m-2 items-center transition-color duration-75 focus:outline-none', colorClass]"
  >
    <base-spinner color="currentColor" :size="20" v-if="loading" />
    <slot v-else />
  </button>
</template>

<script>
export default {
  emits: ["click"],
  props: {
    color: {
      type: String,
      default: "gray",
    },
    dark: Boolean,
    loading: Boolean,
  },
  computed: {
    colorClass() {
      return this.dark
        ? `text-${this.color}-300 hover:text-${this.color}-300 hover:bg-${this.color}-700 focus:ring-2 focus:ring-offset-2 focus:ring-${this.color}-700`
        : `text-${this.color}-500 hover:text-${this.color}-500 hover:bg-${this.color}-100 focus:ring-2 focus:ring-offset-2 focus:ring-${this.color}-500`;
    },
  },
};
</script>
